<template>
  <b-card :title="$t('label_reports_genderGap_generalSummary_outlook_title')">
    <p class="card-text mb-0">
      {{ $t("label_reports_genderGap_generalSummary_outlook_description") }}
    </p>
    <div v-if="backButtom" class="up">
      &larr;
      {{ $t("label_reports_genderGap_generalSummary_outlook_up_buttom") }}
    </div>
    <div :id="alias" class="feature" :style="{ height: height }" />
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import { ChartTreemapConsolidated } from "../../utils/ChartTreemap";

// https://codepen.io/anon/pen/JejGxW

export default {
  name: "CardChartTreemapConsolidated",
  props: {
    alias: {
      type: String,
      default: "treemapId",
    },
    height: {
      type: String,
      default: "400px",
    },
    backButtom: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      /* pillar: {}*/
    };
  },
  computed: mapGetters(["getPillarsDataConsolidated"]),
  watch: {
    /*    pillar: function (newVal, oldVal) {
      console.log('UPDATEING')
      var svg1 = this.$d3.select('#' + this.alias)
      svg1.selectAll('.node').remove()
      this.createTreemap()
    },*/
    getPillarsDataConsolidated: function () {
      console.log("UPDATEING");
      var svg1 = this.$d3.select("#" + this.alias);
      svg1.selectAll(".node").remove();
      this.createTreemap();
    },
  },
  created() {
    console.log("created treemap");
  },
  mounted() {
    /* this.pillar = this.getPillarsDataConsolidated*/
    this.createTreemap();
    /*    this.$store.watch(this.$store.getters.getPillarsDataConsolidated(), n => {
      console.log('UPDATEING')
      var svg1 = this.$d3.select('#' + this.alias)
      svg1.selectAll('.node').remove()
      this.pillar = n
      this.createTreemap()
    })*/

    // This let update the graphic when the language change
    this.unsubscribe = this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case "SET_LANG":
          var svg = this.$d3.select("#" + this.alias);
          svg.selectAll(".node").remove();
          this.createTreemap();
          break;
      }
    });
  },
  beforeDestroy() {
    console.log("Destroy Treemap!!!");
    this.unsubscribe();
  },
  updated() {},
  methods: {
    createTreemap: function () {
      this.treemap = new ChartTreemapConsolidated(
        this.getPillarsDataConsolidated,
        this.alias
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/* components/cards/CardChartTreemap.vue */
@import "../../assets/css/variables.scss";

.up {
  font: bold 14px/1 $font-subtitle;
  color: white;
  padding: 8px;
  background-color: $primary-color;
  float: left;
  cursor: pointer;
  &:hover {
    background-color: $primary-pattern;
  }
}
.feature {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0px;
  overflow: hidden;
}

.node {
  position: absolute;
  background: transparent  no-repeat 50% / cover;
  overflow: hidden;
  opacity: 1;
  transition: opacity 0.8s;
  cursor: pointer;
  border: 1px solid #fff;
  .label {
    display: inline;
    font-size: 1rem;
    font-family: $font-subtitle;
    position: absolute;
    padding: 0;
    margin: 0;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    transition: color 0.4s, opacity 0.8s, filter .8s;
    width: 90%;
    text-align: center;
    p {
      margin-bottom: 0rem;
    }
    .index {
      font-size: 1.2rem !important;
    }
    .leaf:hover {
      text-decoration: underline;
    }
  }
  &.hide {
    opacity: 0;
    pointer-events: none;
    .label {
      filter: blur(10px);
    }
  }
  &:hover {
    .label {
      opacity: 1;
    }
  }
  &.level-0 {
    z-index: 4;
    font-size: 15vmin;
    display: none;
  }
  &.level-1 {
    z-index: 3;
    font-size: 10vmin;
  }
  &.level-2 {
    z-index: 2;
    font-size: 5vmin;
  }
  &.level-3 {
    z-index: 1;
    font-size: 2.5vmin;
  }
}
.AddComment {
  color: #949293;
  position: absolute;
  bottom: -20px;
  right: 15px;
  font-weight: bold;
  cursor: pointer;
  .AddCommentPlus {
    font-size: 30px;
    font-weight: 100;
    background-color: #949293;
    color: #ffffff;
    padding: 2px;
    line-height: 29px;
    display: inline-block;
    margin-left: 10px;
  }
}
.card-title {
  text-align: left;
}
</style>
